export function homeHeroTabs() {
	const blocks = document.querySelectorAll( '.property-search-x' );

	blocks.forEach( block => {
		const tabs  = block.querySelectorAll( '.tab-container .tab' );

		tabs.forEach( tab => {
			tab.addEventListener( 'click', () => {
				const panelId = tab.getAttribute( 'id' ).replace( 'tab', 'panel' );

				// Hide all panels
				block.querySelectorAll( '.tabpanel' ).forEach( panel => {
					panel.setAttribute( 'aria-hidden', 'true' );
				});

				// Deselect all tabs
				tabs.forEach( t => {
					t.setAttribute( 'aria-selected', 'false' );
				});

				// Show the selected panel
				block.querySelector( `#${ panelId }` ).setAttribute( 'aria-hidden', 'false' );

				// Set the selected tab as selected
				tab.setAttribute( 'aria-selected', 'true' );
			} );
		} );
	} );
}